// extracted by mini-css-extract-plugin
module.exports = {"quoteContainer":"avNu5pewThWHBCJTJ-gF_","RatingInfo":"_2jBjeOcij0zM7Tj8Bxuygl","CardName":"tFjEPpiC1Hu_jBvkU9RLL","CardComment":"_2XGwDdui2DI0jQfDK-j_Vi"};